// extracted by mini-css-extract-plugin
export default {"container":"Progress-index__container--xkiGb","planned":"Progress-index__planned--JnSys","progress":"Progress-index__progress--f_jMD"};